import LocationsTableItem from './LocationsTableItem'

export default function LocationsTable( props: any ): JSX.Element {
  const { locations, currentUser, refetch } = props

  return (
    <>
      <div className="px-2 2xl:px-4 rounded-3xl overflow-x-auto">
        <div className={ `bg-white rounded-2xl p-2 2xl:p-4 w-full grid grid-locations-table-cols-admin gap-4` }>
          <div className="flex justify-center font-bold flex-col">Name</div>

          <div className="text-blue-header font-bold">Email</div>

          <div className="text-blue-header font-bold">Address</div>

          <div className="flex justify-center font-bold items-center">&nbsp;</div>
        </div>
      </div>

      <div className="bg-blue-subtle p-2 2xl:p-4 rounded-3xl overflow-x-auto space-y-2 2xl:space-y-4">
        { locations.map( ( location: any, index: any ): any =>
                       <LocationsTableItem
                         key={ index }
                         location={ location }
                         currentUser={ currentUser }
                         refetch={ refetch }
                       /> ) }
      </div>
    </>
  )
}
